const executionStatusGroup = [
  {
    label: '待发货',
    value: '1',
    en: 'receivingStsPendingNum',
    count: 0,
  },
  {
    label: '部分发货',
    value: '2',
    en: 'receivingStsPartNum',
    count: 0,
  },
  {
    label: '已发货',
    value: '3',
    en: 'receivingStsAllNum',
    count: 0,
  },
  {
    label: '无需发货',
    value: '4',
    en: 'receivingStsCanceledNum',
    count: 0,
  },
];

// import * as Moment from 'dayjs';

function convertToName (enums, value) {
  let label = '--';

  for (let v of enums) {
    if (Number(v.value) === Number(value)) {
      label = v.label;
      break;
    }
  }

  return label;
}

export function setOrderShipTable () {
  return [
    {
      title: '收货信息',
      dataIndex: 'receiverDetailAddress',
      key: 'receiverDetailAddress',
      width: 260,
      ellipsis: true,
      customRender: (text, row) => {
        const obj = {
          children: `${row.receiverName || ''}-${row.receiverPhone || ''}-${row.receiverProvinceName || ''}${row.receiverCityName || ''}${row.receiverAreaName || ''}${row.receiverDetailAddress || ''}` || '--',
          attrs: row.rowSpan ? { rowSpan: row.rowSpan } : { rowSpan: 0 },
        };
        return obj;
      },
    },
    {
      title: '订单编号',
      dataIndex: 'code',
      key: 'code',
      width: 160,
      ellipsis: true,
      customRender: (text, row) => {
        const obj = {
          children: text || '--',
          attrs: row.rowSpan ? { rowSpan: row.rowSpan } : { rowSpan: 0 },
        };
        return obj;
      },
    },
    {
      title: '客户抬头',
      dataIndex: 'customerName',
      key: 'customerName',
      width: 200,
      ellipsis: true,
      customRender: (text, row) => {
        const obj = {
          children: text || '--',
          attrs: row.rowSpan ? { rowSpan: row.rowSpan } : { rowSpan: 0 },
        };
        return obj;
      },
    },
    {
      title: '发货状态',
      dataIndex: 'deliveryStatus',
      key: 'deliveryStatus',
      width: 100,
      ellipsis: true,
      customRender: (text, row) => {
        const obj = {
          children: convertToName(executionStatusGroup, text),
          attrs: row.rowSpan ? { rowSpan: row.rowSpan } : { rowSpan: 0 },
        };
        return obj;
      },
    },
    {
      title: '物流填单',
      dataIndex: 'logisticsFillTypeDesc',
      key: 'logisticsFillTypeDesc',
      width: 100,
      ellipsis: true,
      customRender: (text, row) => {
        const obj = {
          children: text || '--',
          attrs: row.rowSpan ? { rowSpan: row.rowSpan } : { rowSpan: 0 },
        };
        return obj;
      },
    },
    {
      title: '商品图片',
      dataIndex: 'image',
      key: 'image',
      width: 120,
      ellipsis: true,
      scopedSlots: { customRender: 'imageList' },
    },
    {
      title: '商品编码（sku）',
      dataIndex: 'outSkuCode',
      key: 'outSkuCode',
      width: 150,
      ellipsis: true,
      customRender: (text, row) => {
        return row.dockingSystem === 'XIAOZI_ERP' ? text || '--' : row.skuCode || '--';
      },
    },
    {
      title: '商品名称',
      dataIndex: 'goodsName',
      key: 'goodsName',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '规格',
      dataIndex: 'specification',
      key: 'specification',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '型号',
      dataIndex: 'model',
      key: 'model',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '所属品牌',
      dataIndex: 'brandName',
      key: 'brandName',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '待发货数量',
      dataIndex: 'unDeliveredQuantity',
      key: 'unDeliveredQuantity',
      width: 110,
      ellipsis: true,
      customRender: (text) => {
        return text || 0;
      },
    },
    {
      title: '是否医疗件',
      dataIndex: 'medicalFlag',
      key: 'medicalFlag',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return text ? '是' : '否';
      },
    },
  ];
}
